import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "detail-section mt-3" }
const _hoisted_2 = { class: "small text-muted" }
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}


export default {
  __name: 'StudentAccessibleRooms',
  props: {
  rooms: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {



const formatAccessibleRoomLabel = (room) => {
  const building = room?.buildingShort;
  const door = room?.doorLabel;
  const name = room?.name;

  if (building && door) {
    return `${building} - ${door}`;
  }

  return building || door || name || '-';
};

const formatRoomPermissionLabel = (room) => {
  if (room?.canCreateRegular) {
    return 'Buchbar';
  }
  if (room?.canCreateWithoutTransaction) {
    return 'ohne Punkte';
  }
  if (room?.canCreateWalkIn) {
    return 'Walk-in';
  }
  return 'sichtbar';
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "text-muted section-title" }, " Sichtbare / buchbare Räume ", -1 /* CACHED */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rooms, (room) => {
      return (_openBlock(), _createElementBlock("div", {
        key: room.id,
        class: "mb-1 d-flex justify-content-between gap-2"
      }, [
        _createElementVNode("span", null, _toDisplayString(formatAccessibleRoomLabel(room)), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_2, _toDisplayString(formatRoomPermissionLabel(room)), 1 /* TEXT */)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    (!__props.rooms.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Keine Räume sichtbar "))
      : _createCommentVNode("v-if", true)
  ]))
}
}

}